// extracted by mini-css-extract-plugin
export default {"resetButton":"eAKfftb","root":"sjSvV9U","value":"eNS7je6","withSynonym":"Low8AUo","prefix":"zIVyQ8n","bullet":"cjNHZWh","label":"zGI0igH","additional":"Az6hPZ_","synonym":"Tn1z9Vh"};